import { FORGOT_PASSWORD } from 'client/redux/forgotPassword/constants';
import { reduceByTypes } from 'client/redux/apiHelpers';

const defaultState = {
  isWaiting: false,
  result: null,
  error: null,
};

export default function reducer (state = defaultState, action) {
  state = reduceByTypes(FORGOT_PASSWORD, state, action, {requestProp: 'isWaiting'});
  return state;
}
